import moment from 'moment'


type DateType = string | Date
type DateRange = { from: DateType, to: DateType }

/**
 * Formates date iso string
 * e.g.:
 *  - '2077' → '2077-01-01T00:00:00.000Z'
 *  - new Date('2077') → '2077-01-01T00:00:00.000Z'
 */
const toISOString = (date: DateType): string => {
  if (date instanceof Date) {
    return date.toISOString()
  }

  return date && parseInt(date, 10) ? (new Date(Date.parse(date))).toISOString() : null
}

const format = (formatStr: string, isUTC: boolean) => (date: DateType): string => {
  const _date = isUTC ? moment.utc(date) : moment(date)
  return _date.format(formatStr)
}

/**
 * Formates date
 * e.g.:
 *  - null, 'MMM DD', false → null
 *  - new Date(2077, 6, 25, 12, 34), 'MMM DD', false → null
 */
const formatDate = (date: DateRange | DateType, formatStr: string, isUTC?: boolean): string => {
  const _format = format(formatStr, isUTC)

  if (!date) {
    return null
  }

  // TODO: number? Where the fuck is number came from?
  if (date instanceof Date || typeof date === 'string' || typeof date === 'number') {
    return _format(date)
  }

  if (typeof date === 'object' && date.from && date.to) {
    return `${_format(date.from)} - ${_format(date.to)}`
  }

  throw new Error('Wrong date format')
}


export default {
  toISOString,
  formatDate,
}
